module.exports = __webpack_public_path__ + "media/R03.b833e15e.mp4";